import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FixedSizeList as List } from 'react-window';
import Row from '../Spreadsheet/Row';

const styles = () => ({
  rows: {
    position: "relative",
    backgroundColor: '#FFFFFF',
    '-webkit-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    '-moz-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.15)',
  },
  listContainer: {
    height: '100%',
    width: '100%',
  },
});

class SearchResultPanel extends React.Component {
  constructor(props) {
    super(props);
    this.listRef = null;
  }

  componentDidUpdate(prevProps) {
    const prevPage = prevProps.pageInfo && prevProps.pageInfo.current_page;
    const currentPage = this.props.pageInfo && this.props.pageInfo.current_page;

    if (prevPage !== currentPage) {
      if (this.listRef) {
        this.listRef.scrollToItem(0);
      }
    }
  }

  /**
   * 前ページまでの項目の個数を返す
   *
   * @see 1ページあたり20件表示で3ページ目の表示であれば40を返す
   * @return number
   */
  getUntilBeforePageItemCount = () => {
    const { pageInfo } = this.props;

    const perPage = pageInfo ? pageInfo.per_page : 0;
    const currentPage = pageInfo ? pageInfo.current_page : 0;

    return perPage * (currentPage - 1);
  }

  /**
   * チェックされているか真偽値を返す
   *
   * @param object item
   * @param number index
   * @return bool isChecked
   */
  isChecked = (item, index) => {
    const {
      isSelectAll,
      selectedItems,
      unselectedItems,
      selectCount,
    } = this.props;

    let isChecked = false;

    if (isSelectAll) {
      isChecked = index < selectCount;
    }

    if (isChecked) {
      if (unselectedItems.has(item.id)) {
        isChecked = false;
      }
    } else {
      if (selectedItems.has(item.id)) {
        isChecked = true;
      }
    }

    return isChecked;
  }

  /**
   * 表示するか真偽値を返す
   *
   * @return bool
   */
  isRender = () => {
    return this.props.items.length > 0;
  }

  render() {
    const {
      classes,
      items,
    } = this.props;

    const count = this.getUntilBeforePageItemCount();

    const itemData = {
      items,
      count,
      props: {
        ...this.props,
        isChecked: this.isChecked,
      },
    };

    return (
      this.isRender() ? (
        <div style={this.props.style} className={classes.rows}>
          <div className={classes.listContainer}>
            <List
              ref={ref => this.listRef = ref}
              height={800}
              itemCount={items.length}
              itemSize={105}
              width="100%"
              itemData={itemData}
            >
              {Row}
            </List>
          </div>
        </div>
      ) : null
    );
  }
}

SearchResultPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  user: PropTypes.object,
  goTo: PropTypes.func.isRequired,
  items: PropTypes.array,
  selectedItems: PropTypes.object,
  unselectedItems: PropTypes.object,
  pageInfo: PropTypes.object,
  isSelectAll: PropTypes.bool,
  selectCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  filterIntentKeywords: PropTypes.array,
  enableExecutiveListAdvancedSearch: PropTypes.bool,
  handleSelectItem: PropTypes.func.isRequired,
  toggleCsvDownloadDialog: PropTypes.func.isRequired,
  toggleExecDetailItemDialog: PropTypes.func.isRequired,
  togglePlanDialog: PropTypes.func.isRequired,
  togglePromotePlanChangeDialog: PropTypes.func.isRequired,
  // AI生成タグ関連
  selectedAiTagName: PropTypes.string,
};

export default withStyles(styles)(SearchResultPanel);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/panels/SearchResultPanel.jsx